/**
 * Formats any number to 12,345.67 円
 * @param amount
 * @returns amount in Japanese Yen (円)
 */
const formatToCurrency = (amount: number, hideSymbol?: boolean) => {
  const prefix = amount < 0 ? "-" : "";
  const formatted = new Intl.NumberFormat("ja-JP").format(Math.abs(amount));

  if (hideSymbol) {
    return `${prefix}${formatted}`;
  }

  return `${prefix}${formatted} \u5186`;
};

export default formatToCurrency;
